/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { ManufacturersTabelHeader } from './ManufacturersTableHeader';
import { manufacturerGridLabel } from './ConstantData';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { Link } from 'react-router-dom';


const Manufacturers = (props) => {
  const { fullScreenView, handleFullScreenView } = props;
  const [hoverUnder, setHoverUnder] = React.useState(false);
  const [gridApi, setGridApi] = useState(null);
  // on grid ready for manufacturer table
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  return (
    <div className="row" data-testid='contract-table-grid-component'>
      <div className="col-sm-12">
        <TableGridWithFeatures
          data-testid="contact-anomalies-Manufacturers-grid"
          rowSelection={'single'}
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
          gridCall={onGridReady}
          columnDefs={ManufacturersTabelHeader}
          rowData={
            props.mfgValues && props.mfgValues.length != 0 ? [props.mfgValues] : props.mfgValues
          }
          exportFile={true}
          animateRows={true}
          sideBar={false}
          fileName={manufacturerGridLabel}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown={true}
          suppressCellFocus={true}
          onCellFocused={onCellFocused}
          onFilterData={false}
          frameworkComponents={{
            ManufacturerIdRenderer: (cellInfo) => {
              return (
                <div
                  className={
                    hoverUnder ? 'frr-text-decoration-underline' : ''
                  }
                    >
                  <Link
                    to="#"
                    role="button"
                    onClick={() => {
                      props.goToManufacturer(cellInfo)
                    }}
                    onMouseOver={() => {
                      setHoverUnder(true);
                    }}
                    onMouseOut={() => {
                      setHoverUnder(false);
                    }}
                  >
                    {cellInfo && cellInfo.value}
                  </Link>
                </div>
              );
            },
          }}
        />
      </div>
    </div>
  );
};
export default Manufacturers;
